module.exports = {"id":"199651","name":"Fernando Canesín","rating":"71","photo":"./data/images/photos/2/199651.png","club":{"name":"KV Ostende","logo":"./data/images/clubs/KVOstende.png"},"positions":["MD","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FernandoCanesin0.json
// module id = 1415
// module chunks = 0